export default __webpack_public_path__ + "static/premio-co-c9ceec6df7d81cc44b7aaf7fc3a4ddbe.png";